<template>
  <div>
    <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
      <template slot-scope="{ item }">
        <td>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-row>
                <v-col cols="12" md="3">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue">
                      <v-icon dark>mdi-google-classroom</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <p class="caption grey--text">
                        Nama Kelompok KP
                      </p>
                      <span class="body-1"> {{ $getDeepObj(item, 'nama') || '-' }} </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <v-label color="caption"><small>Jumlah Sekolah</small></v-label>
                      </v-list-item-title>
                      <v-list-item-subtitle class="link black--text body-2">
                        <span class="blue--text"> {{ (item.psp_kp_pa_sekolahs || []).length || 0 }} </span> Sekolah
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <v-label color="caption"><small>Nama Fasilitator</small></v-label>
                      </v-list-item-title>
                      <v-list-item-subtitle class="link black--text body-2">
                        {{ getInfoPa(item) || '-' }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <v-label color="caption"><small>Aksi</small></v-label>
                      </v-list-item-title>
                      <v-list-item-subtitle class="link black--text body-2">
                        <v-btn small color="primary" @click="$emit('detail', item)">
                          <v-icon left>mdi-eye</v-icon>
                          Lihat Detail
                        </v-btn>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </td>
      </template>
    </base-list-table>
  </div>
</template>

<script>
import BaseListTable from '@/components/base/BaseListTable';
export default {
  name: 'PendampinganLokakarya',
  components: { BaseListTable },
  props: {
    data: {
      type: [Array, Object],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: [String, Number],
    },
    actions: {
      type: Array,
    },
    allow: {
      type: Function,
    },
  },
  methods: {
    getInfoPa(data) {
      const pspKpPaId = data.psp_kp_pa_id || '';
      const pendampingan = (data.psp_kp_pa_pendampingans || []).filter((p) => p.psp_kp_pa_id === pspKpPaId);

      return this.$getDeepObj(pendampingan[0] || {}, 'psp_profil_pa.ptk.nama') || '';
    },
  },
};
</script>

<style scoped></style>
